import BaseCustomError from './BaseCustomError';

/**
 * @deprecated use v2/components/error-boundary/CustomErrors.ts
 * TODO: remove once offerUtils is migrated to v2
 */
export class OfferIdNotFoundError extends BaseCustomError {
  constructor(message, context) {
    super(message);
    this.context = context;
    this.name = 'OfferIdNotFoundError';
    this.context = context;
    this.cause || (this.cause = (context === null || context === void 0 ? void 0 : context.error) || (context === null || context === void 0 ? void 0 : context.cause));
  }
  getContext() {
    return this.context;
  }
}